import React from 'react';
import {
  Box, List, ListItem, ListItemIcon, ListItemText, Paper, Typography,
} from '@mui/material';
import Button from '@mui/material/Button';
import SpeedIcon from '@mui/icons-material/Speed';
import BoltIcon from '@mui/icons-material/Bolt';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import useRUMView from 'common-datadog/useRUMView';

import TrustpilotOppLoans from './TrustpilotOppLoans';
import Screen from '../Screen';
import Disclaimers from '../Disclaimers';

import { container, btn } from './styles';
import { DISCLAIMER_0, DISCLAIMER_1 } from './constants';
import OppLoansLogo from '../../images/opploans.png';

const OpploansListItem = ({ children, Icon }) => (
  <ListItem>
    <ListItemIcon sx={{ minWidth: 0 }}>
      <Icon sx={{ color: '#0528A0' }} />
    </ListItemIcon>
    <ListItemText primaryTypographyProps={{ variant: 'body2', textAlign: 'left' }}>
      {children}
    </ListItemText>
  </ListItem>
);

const DeclinedToOpploans = () => {
  useRUMView('opploans');

  return (
    <Screen
      header="Unfortunately, your application could not be approved at this time."
      subheader="However, you may have another option:"
    >
      <Paper variant="outlined" sx={container}>
        <Box
          component="img"
          width={160}
          height={45}
          src={OppLoansLogo}
          style={{ objectFit: 'contain' }}
          alt="OppLoans"
        />
        <Typography variant="h4">
          Online loans designed for you.
        </Typography>
        <List sx={{ width: '100%' }}>
          <OpploansListItem Icon={SpeedIcon}>
            Same Day Funding Available
            <sup>*</sup>
          </OpploansListItem>
          <OpploansListItem Icon={BoltIcon}>
            Applying does not affect your Fico® score
          </OpploansListItem>
          <OpploansListItem Icon={MoneyOffIcon}>
            No hidden fees
          </OpploansListItem>
        </List>
        <TrustpilotOppLoans />
        <Typography variant="body2">
          Testimonials reflect the individual&apos;s experience with OppLoans.
        </Typography>
        <Button
          href="https://secure.opploans.com/register/page-1?utm_medium=partners&utm_source=cfs&utm_campaign=lde&partner_id=302"
          sx={btn}
        >
          Apply Now
        </Button>
      </Paper>
      <Disclaimers>
        {DISCLAIMER_0}
        {DISCLAIMER_1}
        DigniFi and WebBank are not affiliated with Opploans.
      </Disclaimers>
    </Screen>
  );
};

export default DeclinedToOpploans;
